import { Logo } from '@/components/brand/Logo';

/**
 * 768px 未満にだけ出る上端の帯。
 *
 * サイドバーをドロワーに畳むと、ロゴもナビへの入口も画面から消える。
 * その 2 つをここが引き取る。
 *
 * `sticky` にしてあるのは、表を縦に長く辿った先からでもメニューに戻れるようにするため。
 * 毎回ページ先頭までスクロールし直すことになると、画面間の移動そのものが億劫になる。
 *
 * ボタンは 44px 角を確保する (指で押せる下限)。`Button` の既定 (sm: px-3 py-2) は
 * これに届かないので、ここでは素の `button` に必要な寸法を書く。
 */
export function MobileTopBar({ open, onToggle }: { open: boolean; onToggle: () => void }) {
  return (
    <div className="sticky top-0 z-30 flex items-center gap-3 border-b border-line bg-surface-raised px-2 py-2 md:hidden">
      <button
        type="button"
        onClick={onToggle}
        aria-label="メニュー"
        aria-expanded={open}
        aria-controls="app-sidebar"
        className="flex h-11 w-11 items-center justify-center text-ink-muted hover:bg-surface hover:text-ink focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-700"
      >
        {/* 3 本線は文字ではなく罫線で描く。書体によって字面が変わらないため。 */}
        <span aria-hidden="true" className="flex w-5 flex-col gap-1">
          <span className="h-px bg-current" />
          <span className="h-px bg-current" />
          <span className="h-px bg-current" />
        </span>
      </button>
      <Logo height={24} className="text-brand-500" />
    </div>
  );
}
